<template>
  <div class="limiter">
    <div class="container-login">
      <!-- Barra de topo redesenhada para combinar com a tela Cartao principal -->
      <v-app-bar fixed color="#01579B" app dark height="56px" elevate-on-scroll class="app-bar-compact">
        <v-btn icon class="ml-1" @click="backToCard">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="font-weight-medium ml-2">
          Cardápio Digital
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>

      <!-- Container principal -->
      <v-container fluid class="pa-0">
        <!-- Lista de Cantinas -->
        <v-row v-if="showSnackList" dense>
          <v-col v-for="lojista in lojistas" :key="lojista.id" cols="12" sm="6" md="4" lg="3">
            <v-card class="cantina-card mx-2 mb-3" elevation="1" @click="showProducts(lojista)">
              <v-img :src="lojista.logo" height="120" class="grey lighten-2" @error="setImageToDefault">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
                <v-overlay absolute :value="true" :opacity="0.3">
                  <div class="white--text cantina-nome-overlay">{{ lojista.nome }}</div>
                </v-overlay>
              </v-img>
            </v-card>
          </v-col>
        </v-row>

        <!-- Faixa com Logo do Lojista (somente na lista de produtos) -->
        <v-app-bar v-if="selectedLojistaLogo" fixed color="#FFFFFF" app height="56px" elevate-on-scroll class="app-bar-compact" style="top: 56px;">
          <div class="d-flex align-center mx-auto">
            <img :src="selectedLojistaLogo" alt="Logo do Lojista" class="lojista-logo mr-2">
            <div class="font-weight-medium subtitle-1">{{ lojistaSelecionado.nome }}</div>
          </div>
        </v-app-bar>

        <!-- Lista de Produtos com categorias filtradas -->
        <v-row dense style="padding-bottom: 50px; margin-top: 0px;" v-if="!showSnackList">
          <v-col v-for="categoria in filteredCategorias" :key="categoria.id" cols="12" style="padding: 0px; margin: 0;">
            <div :id="categoria.descricao.normalize('NFD')" class="pt-0">
              <v-chip color="#01579B" text-color="white" x-small class="ml-3 mb-0" style="height: 20px;">
                {{categoria.descricao}}
              </v-chip>
              
              <v-list dense class="pa-0">
                <!-- Produtos disponíveis -->
                <v-list-item
                  v-for="product in filterProductsbyCategoria(categoria.id)"
                  :key="product.id"
                  class="product-item pa-0"
                  dense
                  @click="permitirPedido && product.estoque > 0 && !product.bloqueado ? exibePedido(product) : ''"
                  :class="{'clickable': permitirPedido && product.estoque > 0 && !product.bloqueado}"
                >
                  <v-card 
                    width="100%" 
                    class="product-card" 
                    flat
                  >
                    <div class="d-flex">
                      <div class="product-content flex-grow-1">
                        <div class="product-name">{{ product.descricao }}</div>
                        <div v-if="product.detalhes" class="product-details">{{ product.detalhes }}</div>
                        <div class="product-price-container">
                          <span class="product-price">R$ {{ product.preco }}</span>
                        </div>
                      </div>
                      <div class="product-image-container">
                        <v-img
                          :src="product.urlImagem"
                          @error="setImageToDefault"
                          class="product-image"
                          :aspect-ratio="1"
                          width="80"
                          height="80"
                        ></v-img>
                      </div>
                    </div>
                  </v-card>
                </v-list-item>
                
                <!-- Produtos esgotados/bloqueados -->
                <template v-if="filterEsgotadosByCategoria(categoria.id).length > 0">
                  <v-divider></v-divider>
                  <v-subheader class="grey--text text--darken-1 caption font-weight-medium">
                    <v-icon left small color="grey darken-1">mdi-alert-circle-outline</v-icon>
                    ITENS INDISPONÍVEIS
                  </v-subheader>
                  
                  <v-list-item
                    v-for="product in filterEsgotadosByCategoria(categoria.id)"
                    :key="'esg-'+product.id"
                    class="product-item-unavailable"
                  >
                    <v-card width="100%" class="product-card unavailable" flat>
                      <div class="d-flex">
                        <div class="product-content flex-grow-1">
                          <div class="product-name grey--text">{{ product.descricao }}</div>
                          <div v-if="product.detalhes" class="product-details grey--text text--darken-1">{{ product.detalhes }}</div>
                          <div class="product-price-container">
                            <span class="product-price-unavailable">{{ product.bloqueado ? 'BLOQUEADO' : 'ESGOTADO' }}</span>
                          </div>
                        </div>
                        <div class="product-image-container">
                          <v-img
                            :src="product.urlImagem"
                            @error="setImageToDefault"
                            class="product-image grey-filter"
                            :aspect-ratio="1"
                            width="80"
                            height="80"
                          ></v-img>
                        </div>
                      </div>
                    </v-card>
                  </v-list-item>
                </template>
              </v-list>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    
    <!-- Footer fixo redesenhado -->
    <v-footer padless fixed class="footer">
      <v-card class="flex" flat tile color="#01579B" width="100%" v-if="pedido.itensPedido.length > 0">
        <div class="d-flex align-center justify-space-between py-1 px-3">
          <!-- Lado esquerdo - Ícone do carrinho com contador e total -->
          <div class="d-flex align-center">
            <div class="cart-icon-container mr-3">
              <v-icon color="white" size="22">mdi-cart-outline</v-icon>
              <div class="cart-badge" v-if="pedido.itensPedido.length > 0">
                {{ pedido.itensPedido.length }}
              </div>
            </div>
            <div>
              <div class="white--text caption">Total:</div>
              <div class="white--text font-weight-bold">R$ {{pedido.valor}}</div>
            </div>
            
            <v-btn icon small class="ml-2" @click="pedido.itensPedido = []">
              <v-icon size="18" color="white">mdi-refresh</v-icon>
            </v-btn>
          </div>
          
          <!-- Botão de continuar substituído por versão mais explícita -->
          <v-btn
            color="white"
            class="continue-btn white--text"
            depressed
            small
            @click="dialogoCompra = true"
            :disabled="dialogoCompra"
          >
            <span class="font-weight-medium">Continuar</span>
            <v-icon right size="16" class="ml-1">mdi-arrow-right</v-icon>
          </v-btn>
        </div>
      </v-card>
    </v-footer>

    <!-- Diálogos (mantendo código existente) -->
    <v-dialog v-model="dialogoExibeItem" persistent max-width="400px" scrollable>
      <v-card>
        <v-img 
          :src="produtoSelecionado.urlImagem" 
          width="100%" 
          height="250px"
          @error="setImageToDefault"
          cover
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
          <v-btn 
            fab 
            x-small
            color="white" 
            style="position: absolute; top: 8px; right: 8px;"
            @click="dialogoExibeItem = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-img>

        <v-card-text class="pt-4">
          <div class="text-h6 mb-2">{{ produtoSelecionado.descricao }}</div>
          <div class="text-body-2 grey--text text--darken-1 mb-4">{{ produtoSelecionado.detalhes }}</div>
          <div class="d-flex align-center mb-4">
            <span class="text-h6 primary--text font-weight-bold">R$ {{ produtoSelecionado.preco }}</span>
          </div>
          
          <v-textarea
            outlined
            dense
            label="Observação"
            rows="3"
            v-model="itemPedido.observacao"
            placeholder="Alguma observação especial?"
            class="mb-2"
          ></v-textarea>
        </v-card-text>

        <v-card-actions class="pa-4 pt-0">
          <v-row dense align="center">
            <v-col cols="5">
              <div class="d-flex align-center">
                <v-btn
                  icon
                  color="error"
                  :disabled="itemPedido.quantidade <= 1"
                  @click="itemPedido.quantidade--"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <span class="mx-3 text-h6">{{ itemPedido.quantidade }}</span>
                <v-btn
                  icon
                  color="success"
                  @click="itemPedido.quantidade++"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </v-col>
            <v-col cols="7">
              <v-btn
                block
                color="primary"
                @click="adicionarProduto"
                elevation="2"
                height="44"
              >
                <span class="text-subtitle-1">Adicionar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialogoCompra" transition="dialog-bottom-transition" max-width="600px">
      <v-card>
        <v-toolbar dark color="#01579B" class="elevation-0">
          <v-icon left>mdi-cart-outline</v-icon>
          <v-toolbar-title>Resumo da compra</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogoCompra = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        
        <v-card-text class="pa-0" v-if="pedido.itensPedido.length > 0">
          <!-- Total e informações do pedido -->
          <v-sheet class="pa-4 mb-3">
            <div class="d-flex justify-space-between">
              <div>
                <div class="grey--text text--darken-1 caption mb-1">Total do pedido</div>
                <div class="headline primary--text font-weight-bold">R$ {{pedido.valor}}</div>
              </div>
              <div class="text-right">
                <div class="grey--text text--darken-1 caption mb-1">Itens</div>
                <div class="body-1">{{pedido.itensPedido.length}} {{pedido.itensPedido.length > 1 ? 'produtos' : 'produto'}}</div>
              </div>
            </div>
          </v-sheet>
          
          <!-- Lista de itens -->
          <v-list class="py-0">
            <v-subheader class="grey--text text--darken-2 body-2 font-weight-medium">ITENS DO PEDIDO</v-subheader>
            <v-list-item
              v-for="(item, index) in pedido.itensPedido"
              :key="index"
              class="px-4 py-2"
            >
              <v-list-item-avatar class="mr-3 mt-0">
                <v-chip color="#01579B" dark>{{item.quantidade}}</v-chip>
              </v-list-item-avatar>
              
              <v-list-item-content>
                <v-list-item-title class="subtitle-1">{{ item.descricao }}</v-list-item-title>
                <v-list-item-subtitle v-if="item.observacao" class="caption">
                  <v-icon x-small color="grey darken-1" class="mr-1">mdi-note-text-outline</v-icon>
                  {{ item.observacao }}
                </v-list-item-subtitle>
              </v-list-item-content>
              
              <v-list-item-action>
                <span class="green--text text--darken-1 font-weight-medium">
                  R$ {{ (item.preco.replace(',','.') * item.quantidade).toFixed(2).replace('.',',') }}
                </span>
              </v-list-item-action>
            </v-list-item>
            
            <v-divider></v-divider>
          </v-list>
          
          <!-- Informações do estabelecimento -->
          <v-sheet class="pa-4">
            <div class="grey--text text--darken-1 caption mb-1">Estabelecimento</div>
            <div class="d-flex align-center">
              <v-avatar size="24" class="mr-2">
                <v-img :src="selectedLojistaLogo" @error="setImageToDefault"></v-img>
              </v-avatar>
              <span class="body-2">{{ lojistaSelecionado ? lojistaSelecionado.nome : '' }}</span>
            </div>
          </v-sheet>
        </v-card-text>
        
        <v-card-actions class="pa-4 pt-0">
          <v-btn 
            block 
            color="#01579B" 
            dark 
            height="44" 
            class="elevation-1"
            @click="verificaCartao"
          >
            <v-icon left>mdi-credit-card-outline</v-icon>
            Concluir pedido
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Sucesso da Operação -->
    <v-dialog persistent v-model="dialogoOperacao" max-width="400">
      <v-card>
        <v-card-text class="pt-6 pb-4 text-center">
          <v-icon size="64" color="success" class="mb-4">mdi-check-circle</v-icon>
          <h2 class="text-h5 font-weight-medium mb-2">Pedido Recebido!</h2>
          <p class="text-body-1 grey--text text--darken-1 mb-0">
            Seu pedido foi recebido com sucesso e será preparado para entrega no horário de intervalo do aluno.
          </p>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-btn
            block
            color="primary"
            @click="dialogoOperacao = false"
            height="44"
          >
            <span class="text-subtitle-1">Entendi</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal de Tipo de Leitura -->
    <v-dialog v-model="dialogoTipoLeitura" persistent max-width="400">
      <v-card>
        <v-card-text class="pt-6 pb-4 text-center">
          <v-icon size="64" color="primary" class="mb-4">mdi-qrcode-scan</v-icon>
          <h2 class="text-h5 font-weight-medium mb-4">Como deseja ler o cartão?</h2>
          <v-row class="px-4">
            <v-col cols="12" class="pb-0">
              <v-btn
                block
                color="primary"
                height="44"
                class="mb-3"
                @click="configuraTipoLeitura('CÂMERA')"
              >
                <v-icon left>mdi-camera</v-icon>
                <span class="text-subtitle-1">Usar câmera</span>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                block
                color="#15AAF4"
                dark
                height="44"
                @click="configuraTipoLeitura('LEITOR')"
              >
                <v-icon left>mdi-qrcode</v-icon>
                <span class="text-subtitle-1">Usar leitor</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Modal de Captura QR Code -->
    <v-dialog persistent v-model="dialogoCaptura" max-width="400">
      <v-card>
        <v-card-text class="pt-6 text-center">
          <v-icon size="64" color="primary" class="mb-4">{{ tipoLeitura === 'CÂMERA' ? 'mdi-camera' : 'mdi-qrcode-scan' }}</v-icon>
          <h2 class="text-h5 font-weight-medium mb-4">Leitura do Cartão</h2>
          
          <!-- Conteúdo específico para câmera -->
          <div v-if="tipoLeitura == 'CÂMERA'" class="mb-4">
            <qrcode-stream @decode="realizarPedido" v-if="dialogoCaptura"></qrcode-stream>
          </div>
          
          <!-- Conteúdo específico para leitor -->
          <div v-if="tipoLeitura == 'LEITOR'" class="mb-4">
            <p class="text-body-1 grey--text text--darken-1">
              Aproxime o QR Code do seu cartão de consumo ao leitor
            </p>
            <v-text-field
              v-model="codigoQrCode"
              id="campoCaptura"
              @keydown.enter="realizarPedido(codigoQrCode)"
              @blur="focaCampo"
              style="position: absolute; left: -99999px;"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-btn
            block
            color="error"
            @click="dialogoCaptura = false"
            height="44"
          >
            <span class="text-subtitle-1">Fechar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <loading :active.sync="isLoading" :can-cancel="true" color="#01579B" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />

    <!-- Modal de Saldo Insuficiente -->
    <v-dialog v-model="dialogoSaldoInsuficiente" max-width="400">
      <v-card>
        <v-card-text class="pt-6 pb-4 text-center">
          <v-icon size="64" color="error" class="mb-4">mdi-alert-circle</v-icon>
          <h2 class="text-h5 font-weight-medium mb-2">Saldo Insuficiente</h2>
          <div class="text-body-1 grey--text text--darken-1 mb-4">
            Seu saldo atual não é suficiente para realizar este pedido.
          </div>
          <v-divider class="mb-4"></v-divider>
          <div class="d-flex justify-space-between align-center px-4">
            <div class="text-left">
              <div class="caption grey--text text--darken-1">Seu saldo atual</div>
              <div class="text-h6 error--text font-weight-medium">R$ {{ cartaoConsumo.saldo }}</div>
            </div>
            <div class="text-right">
              <div class="caption grey--text text--darken-1">Valor do pedido</div>
              <div class="text-h6 primary--text font-weight-medium">R$ {{ pedido.valor }}</div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-btn
            block
            color="primary"
            @click="dialogoSaldoInsuficiente = false"
            height="44"
          >
            <span class="text-subtitle-1">Entendi</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'

  export default {
    components: { Snackbar, Loading, },
    name: 'Caixa',
    data() {
      return {
        empresaId: '',
        isLoading: false,
        fullPage: true,
        showSnackList: true,
        lojistaSelecionado: null,
        selectedLojistaLogo: null,
        lojistas: [],
        products: [],
        categorias: [],
        cartaoConsumo: [],
        dialogoExibeItem: false,
        dialogoCompra: false,
        produtoSelecionado: {
          descricao: '',
          detalhes: '',
          urlImagem: '',
          preco: '',
          id: null
        },
        itemPedido: {
          observacao: '',
          quantidade: 1,
        },
        pedido: {
          valor: 0.00,
          itensPedido: [],
        },
        virtualScrollKey: 0,
        dialogoOperacao: false,
        respostaTransacao: [],
        cartaoPermiteCompras: null,
        dialogoTipoLeitura: false,
        tipoLeitura: '',
        dialogoCaptura: false,
        codigoQrCode: '',
        permitirPedido: null,
        totem: null,
        updateKey: 0,
        produtosBloqueados: [],
        dialogoSaldoInsuficiente: false,
      }
    },

    computed: {
      selectedSnackProducts() {
        return this.products.filter(product => product.lojistaId === this.lojistaSelecionado.id);
      },
      
      // Computed property para categorias filtradas (corrigindo erro de linter)
      filteredCategorias() {
        return this.categorias.filter(categoria => 
          this.filterProductsbyCategoria(categoria.id).length > 0
        );
      }
    },

    mounted() {
      if (sessionStorage.getItem('qrCodeCartao')) {
        this.carregaLojistas('situacao', false, sessionStorage.getItem('empresaId'))
        this.carregaCartaoConsumo(sessionStorage.getItem('qrCodeCartao'))
      } else if (!sessionStorage.getItem('qrCodeCartao') && !sessionStorage.getItem('tipoLeitura')) {
        this.carregaLojistas('deliveryTotem', true, sessionStorage.getItem('empresaId'))
        this.dialogoTipoLeitura = true
      } else if (sessionStorage.getItem('tipoLeitura')) {
        this.carregaLojistas('deliveryTotem', true, sessionStorage.getItem('empresaId'))
        this.tipoLeitura = sessionStorage.getItem('tipoLeitura')
        this.cartaoPermiteCompras = true
      }

      if (localStorage.getItem('consumidor')) {
        if (JSON.parse(localStorage.getItem('consumidor')).produtosBloqueados && JSON.parse(localStorage.getItem('consumidor')).produtosBloqueados.length > 0) {
          this.produtosBloqueados = JSON.parse(localStorage.getItem('consumidor')).produtosBloqueados
        }
      }
    },

    watch: {
      'pedido.itensPedido'() {
        let valorPedido = 0

        for (let i = 0; i < this.pedido.itensPedido.length; i++) {
          valorPedido += parseFloat(this.pedido.itensPedido[i].preco.replace(',','.')) * this.pedido.itensPedido[i].quantidade
        }

        this.pedido.valor = valorPedido.toFixed(2).replace('.',',')
      },

      dialogoCompra(val) {
        if (val) {
          this.virtualScrollKey++;
        }
      },

      dialogoOperacao(val) {
        if (val == false) {
          this.dialogoCompra = false
          this.pedido.itensPedido = []
        }
      },

      dialogoCaptura(val) {
        if (val == false) {
          this.codigoQrCode = ''
        }
      },
    },

    methods: {
      async showProducts(lojistaObj) {
        this.lojistaSelecionado = lojistaObj
        const lojista = this.lojistas.find(l => l.id === lojistaObj.id);
        if (lojista) this.selectedLojistaLogo = lojista.logo; // Armazena o logo do lojista selecionado

        await axios.get(baseApiUrl + 'Categorias?filter={"where":{"lojistaId":"' + lojistaObj.id + '"}}')
        .then(response => {
          this.categorias = response.data
          this.categorias.push({
            descricao: 'Outros',
          })
        })

        await axios.post(baseApiUrl + 'Produtos/ativos', {"lojistaId": lojistaObj.id})
        .then(response => {
          this.products = response.data

          for (let i = 0; i < this.products.length; i++) {
            for (let j = 0; j < this.produtosBloqueados.length; j++) {
              if (this.products[i].id == this.produtosBloqueados[j]) {
                this.products[i].bloqueado = true
              }
            }
          }

          if (this.totem) {
            this.permitirPedido = this.lojistaSelecionado.deliveryTotem && this.cartaoPermiteCompras ? true : false
          } else {
            this.permitirPedido = this.lojistaSelecionado.delivery && this.cartaoPermiteCompras ? true : false
          }
        })

        this.showSnackList = false;
        this.scrollToClass()
        this.updateKey++
      },

      setImageToDefault(event) {
        event.target.src = "https://site.fo.usp.br/wp-content/uploads/2022/10/sem-foto.jpg";
      },

      backToCard() {
        this.$router.push('/');
      },

      async carregaConfiguracoes() {
        await axios.get(baseApiUrl + 'Configuracoes/findOne?filter={"fields":{"cardapioEmpresaId": true}}')
        .then(response => {
          if (response.data) {
            this.empresaId = response.data.cardapioEmpresaId
          }
        })
      },

      async carregaLojistas(atributo, totem, empresaId) {
        this.isLoading = true
        this.lojistas = []; // Limpa a lista atual para mostrar o loading
        let dados;

        try {
          if (empresaId) {
            this.empresaId = empresaId;
            dados = {"empresaId": empresaId, "chave": atributo};
          }
          else {
            await this.carregaConfiguracoes();
            dados = {"empresaId": this.empresaId, "chave": atributo};
          }

          const response = await axios.post(baseApiUrl + 'Lojistas/porEmpresa', dados);
          
          if (response.data) {
            this.lojistas = response.data;
            this.totem = totem;
            
            // Se houver apenas uma cantina na lista, ir direto para o cardápio
            if (this.lojistas.length === 1) {
              this.showProducts(this.lojistas[0]);
            }
          }
        } catch (error) {
          this.$refs.chamaSnackbar.snack(
            "#EF5350",
            "Não foi possível carregar as cantinas. Tente novamente.",
            "ERRO"
          );
        } finally {
          this.isLoading = false;
        }
      },

      scrollToClass() {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });

        this.updateKey++
      },

      async carregaCartaoConsumo(qrCodeCartao) {
        await axios.post(baseApiUrl + 'CartoesConsumo/porQrCode', {"qrCode": qrCodeCartao})
        .then(response => {
          if (response.data) {
            this.cartaoConsumo = response.data
            this.cartaoPermiteCompras = response.data.situacao
          }
        })
      },

      exibePedido(produto) {
        // Reseta o estado do pedido
        this.itemPedido = {
          observacao: '',
          quantidade: 1
        }
        // Copia profunda do produto selecionado
        this.produtoSelecionado = JSON.parse(JSON.stringify(produto))
        // Abre o modal
        this.dialogoExibeItem = true
      },

      adicionarProduto() {
        if (!this.produtoSelecionado || !this.produtoSelecionado.id) return

        this.pedido.itensPedido.push({
          produtoId: this.produtoSelecionado.id,
          descricao: this.produtoSelecionado.descricao,
          preco: this.produtoSelecionado.preco,
          observacao: this.itemPedido.observacao,
          quantidade: this.itemPedido.quantidade,
        })

        // Fecha o modal
        this.dialogoExibeItem = false
        
        // Reseta o estado
        this.itemPedido = {
          observacao: '',
          quantidade: 1
        }
        this.produtoSelecionado = {
          descricao: '',
          detalhes: '',
          urlImagem: '',
          preco: '',
          id: null
        }
      },

      async realizarPedido(qrCode) {
        var vm = this;
        this.isLoading = true
        let dados = {
          "empresaId": this.empresaId,
          "atendenteId": '',
          "qrCode": '',
          "valor": this.pedido.valor,
          "tipoTransacao": 'CONSUMO',
          "formaTransacao": '',
          "pinUsuario": '',
          "lojistaId": this.lojistaSelecionado.id,
          "itens": this.pedido.itensPedido,
          "forcarTransacao": false,
          "canalPedido": "DELIVERY",
        }

        if (qrCode) {
          dados.qrCode = qrCode
        } else {
          dados.qrCode = this.cartaoConsumo.qrCode
        }

        await axios.post(baseApiUrl + 'CartoesConsumo/novaTransacaoDelivery', dados)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.dialogoCaptura = false
            if (response.data.resultado == 'SUCESSO') {
              this.respostaTransacao = response.data
              this.dialogoOperacao = true
            }
            else if (response.data.resultado == 'SALDO_INSUFICIENTE') {
              vm.dialogoSaldoInsuficiente = true
            }
            else if (response.data.resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
            }
            else if (response.data.resultado == 'QRCODE_INVALIDO') {
              vm.$refs.chamaSnackbar.snack("#F9A825","QR Code inválido","ATENÇÃO")
            }
            else if (response.data.resultado == 'TRANSACAO_INFORMADA_INVALIDA') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Transação informada é inválida","ATENÇÃO")
            }
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350", error.response.data.error.message, "DESCULPE")
        })
      },

      configuraTipoLeitura(tipo) {
        this.tipoLeitura = tipo
        sessionStorage.setItem('tipoLeitura', tipo)
        this.dialogoTipoLeitura = false
        this.cartaoPermiteCompras = true
      },

      verificaCartao() {
        if (this.cartaoConsumo.length == 0) {
          this.dialogoCaptura = true
          if (this.tipoLeitura == 'LEITOR') {
            setTimeout(() => {
              document.getElementById('campoCaptura').focus()
            }, 100);
          }
        } else {
          this.realizarPedido()
        }
      },

      focaCampo() {
        setTimeout(() => {
          document.getElementById('campoCaptura').focus()
        }, 100);
      },

      scrollToCategoryId(id) {
        let element = document.getElementById(id);
        let elementPosition = element.offsetTop;
        let offsetPosition = elementPosition - 5;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      },

      filterProductsbyCategoria(categoriaId) {
        if (categoriaId) {
          // Retorna apenas produtos disponíveis (com estoque e não bloqueados)
          return this.products.filter(produto => 
            produto.categoriaId === categoriaId && 
            produto.estoque > 0 && 
            !produto.bloqueado
          )
        } else {
          // Para a categoria "Outros"
          return this.products.filter(produto => 
            (produto.categoriaId === null || produto.categoriaId === undefined || produto.categoriaId === "") && 
            produto.estoque > 0 && 
            !produto.bloqueado
          )
        }
      },
      
      // Novo método para filtrar itens esgotados por categoria
      filterEsgotadosByCategoria(categoriaId) {
        if (categoriaId) {
          // Retorna apenas produtos esgotados ou bloqueados
          return this.products.filter(produto => 
            produto.categoriaId === categoriaId && 
            (produto.estoque <= 0 || produto.bloqueado)
          )
        } else {
          // Para a categoria "Outros"
          return this.products.filter(produto => 
            (produto.categoriaId === null || produto.categoriaId === undefined || produto.categoriaId === "") && 
            (produto.estoque <= 0 || produto.bloqueado)
          )
        }
      },
    }
  }
</script>

<style scoped>
  .limiter {
    width: 100%;
    margin: 0 auto;
    background-color: #f5f5f5;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    position: relative;
    z-index: 1;
    padding-top: 24px;
    padding-bottom: 80px;
  }

  .app-bar-compact {
    min-height: 56px !important;
  }

  .app-bar-compact .v-toolbar__content {
    padding: 0 8px;
    height: 56px !important;
  }

  .app-bar-compact .v-btn {
    margin: 0;
    height: 40px;
    width: 40px;
  }

  .lojista-logo {
    width: 32px;
    height: 32px;
    object-fit: contain;
    border-radius: 4px;
  }

  .footer {
    flex-shrink: 0;
    z-index: 5;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    box-shadow: 0 -1px 3px rgba(0,0,0,0.1);
  }

  /* Estilos para o carrinho */
  .cart-icon-container {
    position: relative;
    margin-right: 8px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .cart-badge {
    position: absolute;
    top: -6px;
    right: -6px;
    background-color: #EF6C00;
    color: white;
    border-radius: 50%;
    font-size: 10px;
    min-width: 16px;
    min-height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    box-shadow: 0 1px 2px rgba(0,0,0,0.2);
  }

  .continue-btn {
    min-width: 90px !important;
    border-radius: 20px !important;
    height: 32px;
    background-color: #EF6C00 !important;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }

  .continue-btn:hover {
    background-color: #F57C00 !important;
    box-shadow: 0 3px 6px rgba(0,0,0,0.25);
  }

  /* Card de cantina redesenhado */
  .cantina-card {
    transition: box-shadow 0.2s;
    overflow: hidden;
    border-radius: 8px;
    background-color: white;
    height: 100%;
  }

  .cantina-card:hover {
    box-shadow: 0 4px 12px rgba(1, 87, 155, 0.2) !important;
  }

  .cantina-card .v-image {
    border-radius: 8px 8px 0 0;
  }

  .status-chip {
    font-size: 9px;
    height: 18px !important;
    font-weight: 500;
  }

  .cantina-nome-overlay {
    font-size: 1.1rem;
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(0,0,0,0.6);
    font-family: 'Roboto', sans-serif;
  }

  /* Estilos para produtos melhorados */
  .product-item {
    background-color: white;
    margin: 0;
  }
  
  .product-item.clickable {
    cursor: pointer;
  }

  .product-item.clickable:hover .product-card {
    box-shadow: 0 3px 6px rgba(0,0,0,0.1) !important;
    transform: translateY(-1px);
  }
  
  .product-item-unavailable {
    background-color: #f9f9f9;
    margin: 0;
  }

  .product-card {
    border-radius: 8px;
    transition: all 0.2s ease;
    background-color: white !important;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
    margin: 4px 16px;
  }

  .product-card.unavailable {
    background-color: #f9f9f9 !important;
    opacity: 0.85;
  }

  .product-content {
    padding: 12px;
  }
  
  .product-name {
    font-size: 0.95rem;
    font-weight: 500;
    color: #333333;
    line-height: 1.2;
    margin-bottom: 4px;
  }
  
  .product-details {
    font-size: 0.8rem;
    color: #666666;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 1.2;
    margin-bottom: 8px;
  }
  
  .product-price-container {
    margin-top: 4px;
  }
  
  .product-price {
    font-weight: 600;
    color: #01579B;
    font-size: 1rem;
    padding: 4px 8px;
    background-color: rgba(1, 87, 155, 0.08);
    border-radius: 4px;
  }
  
  .product-price-unavailable {
    font-weight: 500;
    color: #E53935;
    font-size: 0.85rem;
    padding: 4px 8px;
    background-color: rgba(229, 57, 53, 0.08);
    border-radius: 4px;
  }

  .product-image-container {
    width: 80px;
    height: 80px;
    margin: 12px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }

  .product-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }
  
  .grey-filter {
    filter: grayscale(0.8) opacity(0.7);
  }

  /* Classes utilitárias */
  .no-break {
    word-wrap: normal;
    word-break: keep-all;
    white-space: pre-line;
  }

  /* Responsividade para mobile */
  @media (max-width: 600px) {
    .cantina-card {
      height: auto;
    }
  }

  /* Formatação do cabeçalho consistente com o resto do aplicativo */
  .v-sheet .text-subtitle-1 {
    letter-spacing: 0.5px;
    font-size: 14px;
  }

  /* Estilo para as categorias dos produtos */
  .v-toolbar-title {
    font-size: 1rem !important;
    letter-spacing: 0.5px;
  }
</style>